import { render, staticRenderFns } from "./EntryReader.vue?vue&type=template&id=4983ef01&scoped=true"
import script from "./EntryReader.vue?vue&type=script&lang=js"
export * from "./EntryReader.vue?vue&type=script&lang=js"
import style0 from "./EntryReader.vue?vue&type=style&index=0&id=4983ef01&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4983ef01",
  null
  
)

export default component.exports